import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ClothesHanger = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M26.497 22.41L19.896 17.439C19.332 16.957 18.688 16.589 18 16.345V14.875C18 14.002 18.564 13.545 19.56 12.814C20.647 12.016 22 11.022 22 9C22 6.243 19.757 4 17 4C14.243 4 12 6.243 12 9C12 9.552 12.448 10 13 10C13.552 10 14 9.552 14 9C14 7.346 15.346 6 17 6C18.654 6 20 7.346 20 9C20 9.963 19.413 10.44 18.376 11.202C17.317 11.979 16 12.947 16 14.875V16C14.572 16 13.189 16.511 12.104 17.439L5.503 22.41C4.548 23.073 4 24.016 4 25C4 26.654 5.346 28 7 28H25C26.654 28 28 26.654 28 25C28 24.016 27.453 23.074 26.497 22.41ZM25 26H7C6.449 26 6 25.551 6 25C6 24.531 6.5 24.151 6.654 24.046C6.666 24.038 6.678 24.029 6.69 24.02L13.333 19.017C13.351 19.003 13.369 18.989 13.386 18.974C14.112 18.346 15.041 17.999 16.001 17.999C16.961 17.999 17.889 18.345 18.616 18.974C18.633 18.989 18.651 19.003 18.669 19.017L25.312 24.02C25.324 24.029 25.335 24.037 25.348 24.046C25.501 24.151 26.002 24.531 26.002 25C26.002 25.551 25.553 26 25.002 26H25Z" />
	</svg>
);

export default ClothesHanger;
